<template>
  <div>
    <v-row justify="center" class="mt-9">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card rounded class="pa-1">
          <v-row class="ma-0">
            <v-col cols="12" lg="8" md="8" sm="6" xs="12">
              <v-card-title>Papers to be reviewed</v-card-title>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="6" xs="12">
              <v-text-field
                id="reviewer-search-input"
                v-model="search"
                outlined
                dense
                label="Search..."
                :append-icon="icon.mdiMagnify"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="myReviews"
            loading-text="Loading papers... Wait a moment."
            :loading="loading"
            :search="search"
          >
            <template v-slot:item.track="{ item }">
              <div>{{ getTrack(item.trackId) }}</div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-icon
                class="mr-6 ml-2"
                @click="editItem(item.id)"
                :id="'reviewer-edit-button-' + item.id"
              >
                {{ icon.mdiPencil }}
              </v-icon>
              <v-icon color="success" v-if="item.reviewed == true">
                {{ icon.mdiCheckboxMarkedCircle }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiMagnify, mdiCheckboxMarkedCircle, mdiPencil } from "@mdi/js";

export default {
  data: () => ({
    icon: {
      mdiMagnify,
      mdiCheckboxMarkedCircle,
      mdiPencil,
    },
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Title", value: "title" },
      { text: "Track", value: "track" },
      {
        text: "Review",
        value: "action",
        sortable: false,
        align: "end",
        justify: "center",
      },
    ],
    search: "",
  }),
  methods: {
    editItem(itemId) {
      this.$parent.$parent.$parent.step++;
      this.$parent.$parent.$parent.editItemId = itemId;
    },
    getTrack(id) {
      let lang = this.$i18n.locale;
      let track = this.tracks.find((track) => track.id == id);

      return track ? track.content[lang].title : "no track";
    },
  },
  computed: {
    papers() {
      return this.$store.getters.papers || [];
    },
    tracks() {
      return this.$store.getters.getTracks || [];
    },
    loading() {
      if (this.$store.getters.papers == null) return true;
      return false;
    },
    user() {
      return this.$store.getters.getUser;
    },
    myReviews() {
      return this.papers.filter((paper) =>
        this.user?.papersToReview?.includes(paper.id)
      );
    },
  },
  async created() {
    await this.$store.dispatch("getPapers");
    await this.$store.dispatch("getTracks");
  },
};
</script>

<style scoped>
.title-custom {
  font-size: 30px;
  font-weight: 300;
  margin: 3% 0% 1% 1%;
}
</style>
